<template>
  <div class="footer_bar">
    <van-tabbar v-model="active">
      <van-tabbar-item v-for="(item,index) in tabbars" :key="index" @click="tab(index,item.name)">
        <span :class="currIndex == index ? active:''">{{ item.title }}</span>
        <template slot="icon" slot-scope="props">
          <svg-icon :icon-class="item.icon" />
        </template>
      </van-tabbar-item>
    </van-tabbar>
  </div>
</template>

<script>
export default {
  name: 'FooterBar',
  components: {},
  data() {
    return {
      currIndex: 0,
      active: 0,
      tabbars: [
        {
          name: 'home',
          title: '来访预约',
          icon: 'home'
        },
        {
          name: 'user',
          title: '个人中心',
          icon: 'user'
        }
      ]
    }
  },
  computed: {},
  watch: {
    '$route.path'(val) {
      val === '/user' ? this.active = 1 : this.active = 0
    }
  },
  created() {
    this.$route.path === '/user' ? this.active = 1 : this.active = 0
  },
  methods: {
    tab(index, val) {
      this.active = index
      this.currIndex = index
      this.$router.push(val)
    }
  }
}
</script>

<style lang="less" >
.footer_bar {
  .svg-icon {
    width: 0.24rem;
    height: 0.24rem;
  }
  .van-tabbar {
    height: 0.49rem;
  }
  .van-tabbar .van-tabbar-item:first-child {
    &:after {
    }
  }
  .van-tabbar-item {
    font-size: 0.1rem;
  }
}
</style>
